export default "__VITE_ASSET__CoeuxI7n__"